// extracted by mini-css-extract-plugin
export default {"td":"TableItemName_td__BbwWw","tooltip":"TableItemName_tooltip__oCTmi"};